import { clientV3SDK } from "@istari-frontend/api-client";
import { V3Models } from "@istari/istari-client";

import type { Conversation, ConversationMessage } from "~/ai-chat/model/conversation";

export async function listConversations(): Promise<Conversation[]> {
  const dtos = await clientV3SDK.listAiConversations();
  return dtos.map(toConversation);
}

export async function createConversation(title: string | null): Promise<Conversation> {
  const dto = await clientV3SDK.createAiConversation({ createConversationRequest: { title } });
  return toConversation(dto);
}

export async function listConversationMessages(conversationId: string): Promise<ConversationMessage[]> {
  const dtos = await clientV3SDK.listAiConversationMessages({ conversationId });
  return dtos.map(toConversationMessage);
}

export async function appendConversationMessage(
  conversationId: string,
  role: ConversationMessage["role"],
  content: string,
): Promise<ConversationMessage> {
  const dto = await clientV3SDK.appendAiConversationMessage({
    conversationId,
    appendMessageRequest: { role: toMessageRole(role), content },
  });
  return toConversationMessage(dto);
}

function toConversation(dto: V3Models.AiConversationDto): Conversation {
  return {
    id: dto.id,
    title: dto.title ?? null,
    created: dto.created,
  };
}

function toConversationMessage(dto: V3Models.AiMessageDto): ConversationMessage {
  return {
    id: dto.id,
    role: toDomainRole(dto.role),
    content: dto.content,
  };
}

function toMessageRole(role: ConversationMessage["role"]): V3Models.MessageRole {
  switch (role) {
    case "user":
      return V3Models.MessageRole.User;
    case "assistant":
      return V3Models.MessageRole.Assistant;
    case "system":
      return V3Models.MessageRole.System;
    default: {
      const exhaustive: never = role;
      throw new Error(`Unknown message role: ${String(exhaustive)}`);
    }
  }
}

function toDomainRole(role: V3Models.MessageRole): ConversationMessage["role"] {
  switch (role) {
    case V3Models.MessageRole.User:
      return "user";
    case V3Models.MessageRole.Assistant:
      return "assistant";
    case V3Models.MessageRole.System:
      return "system";
    default: {
      const exhaustive: never = role;
      throw new Error(`Unknown message role: ${String(exhaustive)}`);
    }
  }
}
